import { createAction, props } from '@ngrx/store';

export const buildInventoryOverview = createAction('[RootInventory] Trigger Overview');

// Types
export const loadTypes = createAction('[RootInventory] Load Types');
export const loadTypesOk = createAction('[RootInventory] Load Types Ok', props<{ types: any[] }>());
export const loadTypesFailed = createAction('[RootInventory] Load Types Failed');

// Inventory Records (purchases)
export const loadRecords = createAction('[RootInventory] Load Records');
export const loadRecordsOk = createAction(
  '[RootInventory] Load Records Ok',
  props<{ records: any[] }>()
);
export const loadRecordsFailed = createAction('[RootInventory] Load Records Failed');

// Item applications (item uses)
export const loadApplications = createAction('[RootInventory] Load Applications');
export const loadApplicationsOk = createAction(
  '[RootInventory] Load Applications Ok',
  props<{ applications: any[] }>()
);
export const loadApplicationsFailed = createAction('[RootInventory] Load Applications Failed');
